





























































import { get, isEmpty } from 'lodash';
import { getUserThumbnailInitials, getUserThumbnailInitialsBackgroundColor } from '@/utils/userThumbnail';
import CoIcon from '../../Atoms/co-icon/CoIcon.vue';
import CoImage from '../../Atoms/co-image/CoImage.vue';
import CoText from '../../Atoms/co-text/CoText.vue';

interface Label {
    imageURL?: string;
    color?: string;
    icon?: string;
}

export default {
    name: 'CoThumbnail',
    components: {
        CoIcon,
        CoImage,
        CoText,
    },
    props: {
        imageURL: {
            type: String,
            default: '',
        },
        link: {
            type: String,
            default: '',
        },
        round: {
            type: Boolean,
            default: false,
        },
        clickable: {
            type: Boolean,
            default: true,
        },
        contentType: {
            type: String,
            default: 'image',
            validator: (value: string) => ['image', 'user', 'page', 'event', 'color', 'icon'].includes(value),
        },
        color: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: 'md',
            validator: (value: string) => ['xs', 'sm', 'ms', 'md', 'lg', 'xl', 'label'].includes(value),
        },
        deletable: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: Boolean,
            default: true,
        },
        label: {
            type: Object as () => Label,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        initials: {
            type: String,
            default: '',
        },
        initialsBackgroundColor: {
            type: String,
            default: '',
        },
        user: {
            type: Object,
            default: null,
        },
        altText: {
            type: String,
            default: '',
        },
        lightbox: {
            type: Boolean,
            default: false,
        },
        online: {
            type: Boolean,
            default: null,
        },
    },
    data() {
        return {
            imageLoadFailed: false,
        };
    },
    computed: {
        url() {
            if (!this.imageURL) {
                return '';
            }

            //  if starts with https://cdnmedia.coapp.io/ or https://media.coapp.io/ return as is
            if (
                this.imageURL.startsWith('https://cdnmedia.coapp.io/') ||
                this.imageURL.startsWith('https://media.coapp.io/')
            ) {
                return this.imageURL;
            }
            // if imageURL starts with https://collaborates.s3.eu-central-1.amazonaws.com/ remove from url
            let tmp = this.imageURL;
            if (this.imageURL && this.imageURL.startsWith('https://collaborates.s3.eu-central-1.amazonaws.com/')) {
                tmp = tmp.replace('https://collaborates.s3.eu-central-1.amazonaws.com/', '');
            } else if (
                this.imageURL &&
                this.imageURL.startsWith('https://projects-headers.s3.eu-central-1.amazonaws.com/')
            ) {
                tmp = tmp.replace('https://projects-headers.s3.eu-central-1.amazonaws.com/', '');
            } else {
                return this.imageURL;
            }

            // replace / with _ in the url
            tmp = tmp.replace(/\//g, '_');

            //  and new prefix https://cdnmedia.coapp.io/legacy/images/
            if (this.size === 'lg') {
                tmp = `https://cdnmedia.coapp.io/legacy/images/${tmp}?w=400`;
                return tmp;
            }
            if (this.size === 'xl') {
                tmp = `https://cdnmedia.coapp.io/legacy/images/${tmp}?w=800`;
                return tmp;
            }
            tmp = `https://cdnmedia.coapp.io/legacy/images/${tmp}?w=200`;

            return tmp;
        },
        classes() {
            return {
                clickable: this.clickable,
                deletable: this.deletable,
                round: this.round,
                [`size-${this.size}`]: true,
                'has-label': !!(this.label && !isEmpty(this.label)),
            };
        },
        placeholderSize() {
            switch (this.size) {
                case 'label':
                    return '75%';
                case 'sm':
                    return '.6rem';
                case 'ms':
                    return '.67rem';
                default:
                    return '1rem';
            }
        },
        textSize() {
            switch (this.size) {
                case 'label':
                    return 'p4';
                case 'xl':
                case 'lg':
                    return 'p1';
                case 'sm':
                    return 'p3';
                case 'ms':
                    return 'p3';
                default:
                    return 'p1';
            }
        },

        showImage() {
            if (this.url && !this.imageLoadFailed) {
                return true;
            }

            return !this.url && !this.color && this.contentType !== 'color' && !this.icon && !this.showInitials;
        },
        showInitials() {
            return this.contentType === 'user' && !!this.thumbnailInitials && (!this.url || this.imageLoadFailed);
        },
        thumbnailInitials() {
            return this.initials || getUserThumbnailInitials(this.user);
        },
        thumbnailInitialsBackgroundColor() {
            return this.initialsBackgroundColor || getUserThumbnailInitialsBackgroundColor(this.user);
        },
    },
    watch: {
        imageURL() {
            this.imageLoadFailed = false;
        },
    },
    methods: {
        get,
        isEmpty,
        handleImageLoaded() {
            this.imageLoadFailed = false;
        },
        handleImageError() {
            // Switch failed user images to initials; keep other image placeholders available.
            this.imageLoadFailed = this.contentType === 'user' && !!this.thumbnailInitials;
        },
        click(event) {
            if (this.link) {
                // stop the click event from propagating to the parent element
                event.stopPropagation();
                this.$router.push(this.link);
                return;
            }

            if (this.clickable) {
                this.$emit('click', event);
            }
        },
    },
};
